import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { motion, AnimatePresence } from 'framer-motion';

import ThumbnailGallery from 'components/ThumbnailGallery';
import Button from 'components/Button';

const MultiGallery = ({ galleries }) => {
    const [activeGallery, setActiveGallery] = useState(0);

    if (!galleries || galleries.length === 0) {
        return null;
    }

    return (
        <Container>
            <GalleryContainer>
                <AnimatePresence mode="wait">
                    {galleries.map((gallery, index) => (
                        activeGallery === index && (
                            <GalleryWrapper
                                key={`gallery-${index}`}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <ThumbnailGallery images={gallery.images || []} />
                            </GalleryWrapper>
                        )
                    ))}
                </AnimatePresence>
            </GalleryContainer>
            
            <ToggleContainer>
                <ButtonGroup>
                    {galleries.map((gallery, index) => (
                        <ToggleButton
                            key={`toggle-${index}`}
                            active={activeGallery !== index}
                            onClick={() => setActiveGallery(index)}
                        >
                            {gallery.name || `Gallery ${index + 1}`}
                        </ToggleButton>
                    ))}
                </ButtonGroup>
            </ToggleContainer>
        </Container>
    );
};

export default MultiGallery;

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const GalleryContainer = styled.div`
    flex: 1;
    width: 100%;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6rem;
`;

const GalleryWrapper = styled(motion.div)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ToggleContainer = styled.div`
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    // gap: 1rem;
    padding-bottom: 3rem;
`;

const ButtonGroup = styled.div`
    border-radius: 999px;
    overflow: hidden;
`;

const ToggleButton = styled(Button)`
    &:not([data-active]) {
        pointer-events: none;
        cursor: default;
    }
`;
